import { useQuery } from "@tanstack/react-query";
import { gqlReq } from "~/libs/gql";
import { GetMaintenanceStatusDocument } from "~/types/__generated/gql/graphql";

void (
	/* GraphQL */ `
		query GetMaintenanceStatus {
			getMaintenanceStatus {
				enabled
				message
			}
		}
	`
);

export const getMaintenanceStatusQueryKey = () => ["getMaintenanceStatus"];

export const useGetMaintenanceStatus = () =>
	useQuery({
		queryKey: getMaintenanceStatusQueryKey(),
		queryFn: ({ signal }) =>
			gqlReq({ document: GetMaintenanceStatusDocument, signal }),
	});
